<template>
    <div>
        <div class="flex rcs notice-wrap">
            <img class="notice-icon" :src="Images.icon_warn" />
            <div class="notice-title">为了便于发放奖金，请如实塡写以下信息</div>
        </div>
        <div class="form-wrap">
            <div class="form-item">
                <div class="form-item-title">账户名称</div>
                <div class="form-item-con flex rcb">
                    <input class="input-item" type="text" placeholder="请输入真实姓名" v-model="formData.real_name" />
                </div>
            </div>
            <div class="form-item">
                <div class="form-item-title">{{formData.account_type == Constants.ALIPAY ? '支付宝账号' : '微信账号'}}</div>
                <div class="form-item-con flex rcb">
                    <input class="input-item" type="number" :placeholder="`请输入${formData.account_type == Constants.ALIPAY ? '支付宝绑定的手机号' : '微信账号'}`" v-model="formData.account" />
                </div>
            </div>
            <div v-if="formData.account_type == Constants.ALIPAY" class="form-item">
                <div class="form-item-title">短信验证码</div>
                <div class="form-item-con flex rcb">
                    <input class="input-item" type="text" placeholder="请输入验证码" v-model="formData.code" />
                    <button class="code-btn-item" :disabled="disabled" :class="disabled === true ? 'on' : ''" @click="_onGetSMSCode">{{ text }}</button>
                </div>
            </div>
            <div class="flex rce form-item form-tips-item" @click="_onSwitchInfoType()">
                <div class="tips">{{formData.account_type == Constants.ALIPAY ? '没有支付宝？填写微信账号' : '我有支付宝，填写支付宝信息'}}</div>
            </div>
        </div>
        <button class="submit-btn-item" @click="_onSubmitSave">保存</button>
    </div>
</template>
<script>
import attrs, { required, alpha_num, chs_phone } from "@utils/validate";
import { validatorDefaultCatch } from "@utils/dialog";
import sendVerifyCode from "@mixins/SendVerifyCode";
import { queryBindStatus, submitBindAccount, getCodeApi, registerVerify } from "@/api/user.js";
export default {
    mixins: [sendVerifyCode],
    data() {
        return {
            smsCodeKey: '',
            formData: {
                account_type: this.Constants.ALIPAY, // WECHAT
                real_name: '',
                account: '',
                code: '',
            }
        };
    },
    mounted() {
        console.log('this.Constants, this.Images---->', this.Constants, this.Images);
        this._onShowLoading();
        this._onGetSMSCodeKey();
        this._onRequestBindStatus();
    },
    methods: {

        async _onGetSMSCodeKey() {
            let result = await getCodeApi()
            if (result.status == 200) {
                this.smsCodeKey = result.data.key;
            }
        },

        async _onRequestBindStatus() {
            let result = await queryBindStatus()
            console.log('result---->', result);
            this._onHideLoading()
            if (result.status == 200 && result.data.is_bind > 0) {
                this.formData = result.data;
            }
        },

        async _onGetSMSCode() {
            if (!this.smsCodeKey) {
                await this._onGetSMSCodeKey();
            }
            let _this = this;
            let { account } = _this.formData;
            try {
                await _this
                    .$validator({
                        account: [
                            required(required.message("手机号码")),
                            chs_phone(chs_phone.message()),
                        ],
                    })
                    .validate({ account });
            } catch (e) {
                return validatorDefaultCatch(e);
            }
            await registerVerify({
                    key: _this.smsCodeKey,
                    phone: _this.formData.account,
                    type: _this.Constants.SMS_BIND_ALIPAY,
                })
                .then((res) => {
                    _this.$dialog.success(res.msg);
                    _this.sendCode();
                })
                .catch((res) => {
                    if (res.data.status === 402) {
                        this._onGetSMSCodeKey();
                    }
                    _this.$dialog.error(res.msg);
                });
        },

        _onSwitchInfoType() {
            this.formData.account_type = this.formData.account_type == this.Constants.ALIPAY ? this.Constants.WECHAT : this.Constants.ALIPAY
        },

        async _onSubmitSave() {
            let { account_type, real_name, account, code } = this.formData;
            let data = this.formData;
            if (!real_name) {
                return this.$dialog.toast({mes: '请输入真实姓名'})
            }
            if (!account) {
                return this.$dialog.toast({mes: `请输入${account_type == this.Constants.ALIPAY ? '支付宝账号' : '微信账号'}`})
            }
            if (!code && account_type == this.Constants.ALIPAY) {
                return this.$dialog.toast({mes: '请输入短信验证码'})
            }

            submitBindAccount(data)
                .then(result => {
                    this.$dialog.toast({ mes: result.msg });
                    setTimeout(() => this.$router.go(-1), 1500);
                })
                .catch(error => {
                    this.$dialog.toast({ mes: error.msg });
                })
        }
    },
};
</script>
<style scoped lang="scss">
.notice-wrap {
    height: 50px;
    padding: 0 15px;
    background: #fef5d7;

    .notice-icon {
        width: 18px;
        height: 18px;
    }

    .notice-title {
        color: #333;
        fontSize: 13px;
        fontWeight: 600;
        margin-left: 10px;
    }
}

.form-wrap {
    background: #fff;
    margin: 15px 15px;
    border-radius: 5px;
    padding: 15px 15px 30px;
    box-shadow: 0px 1px 15px 0px rgba(157, 157, 157, 0.2);

    .form-item {
        display: flex;
        margin: 20px 0;
        align-items: center;

        .form-item-title {
            width: 80px;
            color: #333;
            font-size: 15px;
        }

        .form-item-con {
            flex: 1;
            height: 44px;
            padding: 0 10px;
            border-radius: 4px;
            background: rgba(237, 237, 237, 0.37);

            .input-item {
                flex: 1;
                color: #333;
                font-size: 14px;

                ::placeholder {
                    color: #999999;
                }
            }

            .code-btn-item {
                flex-shrink: 0;
            }
        }
    }

    .form-tips-item {
        color: #666;
        padding: 5px 0;
        font-size: 13px;
        margin-top: -10px;
    }
}

.submit-btn-item {
    width: 6.5rem;
    height: 50px;
    background: #d01112;
    border-radius: 100px;
    box-shadow: 0px 4px 6px 0px rgba(0, 0, 0, 0.1);
    line-height: 50px;
    color: #ffffff;
    font-size: 15px;
    text-align: center;
    margin: -25px auto;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: PingFangSC, PingFangSC-Medium;
    font-weight: 600;
}
</style>